import { useState, useEffect } from "react";
import { Grid, TextField } from "@mui/material";
import moment from "moment";
import "moment/locale/es";

export const parseInitDate = (date) => {
    return new Date(moment(date).startOf("month").tz("America/Mexico_City").format()).toJSON(); 
}
export const parseDate = (date, time) => {
    if(time === "end"){
        return new Date(moment(date).endOf("day").tz("America/Mexico_City").format()).toJSON();
    } else {
        return new Date(moment(date).startOf("day").tz("America/Mexico_City").format()).toJSON();
    }
}
export const initDay = parseInitDate(new Date());
export const endDay = parseDate(new Date(), "end");

export const startDate = initDay.slice(0, 10);
export const endDate = endDay.slice(0, 10);

export const DateRangePicker = (props) => {
    
    const [form, setForm] = useState({
        startDate: (props["startDate"] && props["startDate"].slice(0, 10)) || startDate,
        endDate: (props["endDate"] && props["endDate"].slice(0, 10)) || endDate,
    });

    const [error, setErrors] = useState({
        startDate: "",
        endDate: "",
    });

    const changeValue = (field, e) => {
        let f = form;
        let er = error;

        f[field] = e.target.value;
        if (!e.target.value) {
            er[field] = "Dato obligatorio";
        } else if(new Date(f.startDate) > new Date(f.endDate)) {
            er.startDate = "La fecha de inicio no debe ser mayor a la fecha de fin."
        } else {
            er[field] = "";
        }

        setForm(JSON.parse(JSON.stringify(f)));
        setErrors(JSON.parse(JSON.stringify(er)));
        validate(f, er);
    };

    const validate = (f, er) => {
        if( er.endDate || er.startDate){
            props.updateDates(f, true);
        } else {
            props.updateDates(f, false);
        }
    };

	useEffect(() => {
        let f = form;
        f.startDate = (props["startDate"] && props["startDate"].slice(0, 10)) || startDate
        f.endDate = (props["endDate"] && props["endDate"].slice(0, 10)) || endDate

        setForm(JSON.parse(JSON.stringify(f)))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props])

    return (
        <Grid container spacing={1} width={props.width}>
            <Grid item xs={6}>
                <TextField
                    value={form.startDate}
                    onChange={changeValue.bind(this, "startDate")}
                    label="Fecha de Inicio"
                    size="small"
                    type={"date"}
                    fullWidth
                    InputProps={{
                        inputProps: { max: moment(new Date()).format().slice(0, 10), min: "2006-01-01" },
                    }}
                    error={error.startDate !== ""}
                    helperText={error.startDate ? error.startDate : ""}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    value={form.endDate}
                    onChange={changeValue.bind(this, "endDate")}
                    label="Fecha Final"
                    size="small"
                    type={"date"}
                    fullWidth
                    InputProps={{
                        inputProps: { max: moment(new Date()).add(1, 'day').format().slice(0, 10), min: "2006-01-01" },
                    }}
                    error={error.endDate !== ""}
                    helperText={error.endDate ? error.endDate : ""}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>
        </Grid>
    );
};

export const transormDates = (dates) => {
    let today = new Date().toJSON().substring(0, 10);

    function endDay(start) {
        const desplazamientoHorario = new Date().getTimezoneOffset();
        
        const tiempoZonaHoraria = new Date(start).getTime() + desplazamientoHorario * 60 * 1000;
        const fechaZonaHoraria = new Date(tiempoZonaHoraria);
        fechaZonaHoraria.setHours(23, 59, 59, 999);
        return new Date(fechaZonaHoraria).toJSON();
    }

    function startDay(start) {
        const desplazamientoHorario = -new Date().getTimezoneOffset();

        const tiempoZonaHoraria = new Date(start).getTime() - desplazamientoHorario * 60 * 1000;
        const fechaZonaHoraria = new Date(tiempoZonaHoraria);
        fechaZonaHoraria.setHours(0, 0, 0, 0);
        return new Date(fechaZonaHoraria).toJSON();
    }

    let startDate = startDay(dates.start);
    let endDate = today === dates.end ? new Date() : endDay(dates.end);

    return { start: startDate, end: endDate };
};


export const transformTzDate = (date) => {
    function startDay(start) {
        const desplazamientoHorario = -new Date().getTimezoneOffset();

        const tiempoZonaHoraria = new Date(start).getTime() - desplazamientoHorario * 60 * 1000;
        const fechaZonaHoraria = new Date(tiempoZonaHoraria);
        fechaZonaHoraria.setHours(0, 0, 0, 0);
        return new Date(fechaZonaHoraria).toJSON();
    }

    let result = startDay(date);

    return result;
};

export const generalDate = (date) => {
    const fecha = new Date(date);

    const day = ("0" + fecha.getUTCDate()).slice(-2);
    const month = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
    const year = fecha.getUTCFullYear();
        
    const formatDate = `${day}-${month}-${year}`;

    return formatDate;
};